var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescriptionFill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "description_FILL1_wght400_GRAD0_opsz24",
    d: "M164.5-865.6h5.4a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259h-5.4a.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,164.5-865.6Zm0-3.6h5.4a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641A.871.871,0,0,0,169.9-871h-5.4a.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,164.5-869.2Zm-2.7,7.2a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,160-863.8v-14.4a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,161.8-880h6.458a1.778,1.778,0,0,1,.686.135,1.749,1.749,0,0,1,.574.383l4.365,4.365a1.749,1.749,0,0,1,.382.574,1.777,1.777,0,0,1,.135.686V-863.8a1.733,1.733,0,0,1-.529,1.271A1.733,1.733,0,0,1,172.6-862Zm6.3-12.6a.871.871,0,0,0,.259.641.871.871,0,0,0,.641.259h3.6l-4.5-4.5Z",
    transform: "translate(-160 880)",
    fill: "#5a5a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionFill1);
export default __webpack_public_path__ + "static/media/description_FILL1.2bfe8242eb0eabee367f394c8c48f4a6.svg";
export { ForwardRef as ReactComponent };